import { cn } from 'tailwind-v4/lib/utils'
import type { ChooseOption, ChoosePart } from './types'

/**
 * `choose`: pick one of a few.
 *
 * THE PART THAT PAYS FOR THE WHOLE LAYER. Before it, "which venue did you
 * mean?" was the agent reading three names aloud and hoping one came back
 * intelligibly, over a transcriber that had already turned "Eleventh of
 * October" into "Yllefed o octobar". Three buttons removes an entire class
 * of failure.
 *
 * IT STAYS ANSWERABLE OUT LOUD. Pressing a button sends its label as an
 * ordinary turn, which is exactly what saying "the Perth one" does. The
 * two paths converge before the agent sees them, so there is no second
 * code path to keep in step and no way for the surface to turn a voice
 * assistant into a form.
 *
 * AND IT MOVES OPTIMISTICALLY. An option about a place carries the route
 * trunk resolved when it built the choice, so the tap navigates at once
 * and the agent's answer catches up. Waiting a couple of seconds for a
 * model to re-derive a destination it offered you a second earlier is the
 * kind of slowness that makes a surface feel fake.
 */

export function ChoosePart({
  part,
  onChoose,
}: {
  part: ChoosePart
  onChoose: (option: ChooseOption) => void
}) {
  return (
    <div className="flex min-w-0 flex-col gap-3">
      <p className="text-sm font-medium text-foreground">{part.prompt}</p>
      <div className="flex flex-col gap-2">
        {part.options.map((option) => (
          <button
            key={option.label}
            type="button"
            onClick={() => {
              onChoose(option)
            }}
            className={cn(
              'flex min-w-0 flex-col items-start gap-0.5 rounded-xl border border-border px-4 py-3 text-left',
              'hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
            )}
          >
            <span className="truncate text-sm font-medium text-foreground">
              {option.label}
            </span>
            {option.detail ? (
              <span className="truncate text-xs text-muted-foreground">
                {option.detail}
              </span>
            ) : null}
          </button>
        ))}
      </div>
    </div>
  )
}
